<template>
  <v-container id="industries-section" class="pa-0 pa-md-4 mt-8">
    <v-layout column>
      <v-flex>
        <h3
          class="display-24-18 black--text mt-2 mb-2 info-header"
          v-html="getString(constants, 'CompaniesLobby_AdditionalInfo').Value"
        />       
      </v-flex>
    </v-layout>
    <v-container
      class="industry-wrapper"
      pa-4
      mb-6
      v-for="(industry, index) in industries"
      :key="index"
    >
      <v-layout align-center pr-0 pr-md-6 row>
        <v-flex text-xs>
          <h2 class="black--text bold display-30-24 industry-name">
            <span>{{ industry.KeyValue.Value }}</span>
          </h2>
        </v-flex>
      </v-layout>
      <v-layout align-start column>
        <v-container pa-0>
          <v-layout align-start wrap justify-space-around>
            <v-flex
              v-for="(company, index) in CompaniesByIndustry(industry.KeyValue.Key)"
              :key="index"
              text-center
              class="company-item"
              d-flex
              my-4
            >
              <nuxt-link :to="encodeURI(company.ToUrl)" :title="company.Name">
                <img class="company-img m-auto" :src="company.CompanyLogoLink" :alt="company.Name"/>
              </nuxt-link>
            </v-flex>
          </v-layout>
          <v-flex>
            <a
              :href="industry.Link"
              class="industry-show-more display-20-18 primary--text d-flex"
            >{{ `${constants.Keys[6].KeyValue.Value} ${industry.KeyValue.Value} >` }}</a>
          </v-flex>
        </v-container>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  props: {
    companies: {
      type: Object,
      required: false
    },
    industries: {
      type: Array,
      required: true
    },
    constants: {
      type: Object,
      required: true
    }
  },

  methods: {
    CompaniesByIndustry(index) {
      let items = 6

      if (this.$vuetify.breakpoint.mdAndUp) {
        items = 6
      } else if (this.$vuetify.breakpoint.smOnly) {
        items = 5
      } else {
        items = 4
      }

      return this.companies[parseInt(index)].slice(0, items)
    }
  }
}
</script>

<style lang="scss" scoped>
.industry-wrapper {
  background-color: #f6f7f9;
}

.company-item {
  max-width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  width: 100%;
  flex-grow: 0;
  background-color: white;
  align-items: center;
  justify-content: center;
}

.company-item img {
  transform: scale(0.8);
}

.company-img {
  max-width: 120px;
  height: auto;
  display: flex;
  justify-content: center;
}

.company-item:hover {
  -webkit-box-shadow: rgb(0 0 0 / 15%) 0 0 2px 2px;
  box-shadow: rgb(0 0 0 / 15%) 0 0 2px 2px;
}

.industry-show-more {
  text-decoration: none;
  justify-content: flex-end;
  text-align: left;
}

.industry-name,
.info-header {
  text-align: right;
}

@media only screen and (max-width: 960px) {
  .industry-name,
  .info-header {
    text-align: center;
  }

  .industry-show-more {
    text-align: center;
    justify-content: center;
  }
}
</style>
